import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CodeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 16px;

  & > :first-child {
    display: flex;
    justify-content: flex-end;
    width: 150px;
  }

  & > :last-child {
    max-width: 340px;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
`;
